import { Alert, Text, ExternalLink } from 'roo-ui/components';
import { CONTACT_US_URL } from 'config/constants';
import { contactUsLinkSelected } from 'lib/gaTracking/crossPageEvents';

const NoAvailabilityAlert = () => (
  <Alert variant="error" aria-live="assertive">
    <Text fontWeight="bold" display="block" mb={1}>
      Room is not available on these dates
    </Text>
    Please try different dates, or{' '}
    <ExternalLink underline href={CONTACT_US_URL} onClick={contactUsLinkSelected}>
      contact us
    </ExternalLink>{' '}
    so we can assist you with this change.
  </Alert>
);

export default NoAvailabilityAlert;
